import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import Details from "./pages/Details";
// 👈 Import this so it attaches to the window object automatically
import "./utils/seoTest";

export default function App() {
  return (
    <HelmetProvider>
      <Router>
        <Navbar />  {/* This is inside Router */}
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/details/:services" element={<Details />} />
        </Routes>
      </Router>
    </HelmetProvider>
  );
}